import { apiGet } from './utils';
import type { ShiftHistoryItem, PagedResponse } from '../types';

export const shiftHistoryApi = {
  /**
   * Get shift history for support team (managers only)
   * Requires 'support' role
   */
  async listBySupport(cursor?: string): Promise<PagedResponse<ShiftHistoryItem>> {
    return apiGet<PagedResponse<ShiftHistoryItem>>('/shift-history/list/by-support', {
      cursor,
    });
  },
};
